import { useEffect, useRef } from 'react';

function scrollSelectedTabIntoView(container: HTMLElement, tab: HTMLElement) {
  const tabCenter = tab.offsetLeft + tab.offsetWidth / 2;
  const nextScrollLeft = tabCenter - container.clientWidth / 2;

  container.scrollTo({
    left: nextScrollLeft,
    behavior: 'smooth',
  });
}

export function useScrollSelectedTabIntoView(
  dependencies: unknown[],
  { enabled = true }: { enabled?: boolean } = {}
) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!enabled) return;

    const container = containerRef.current;
    const selectedTab = container?.querySelector<HTMLElement>(
      '[data-selected="true"]'
    );

    if (!container || !selectedTab) return;

    scrollSelectedTabIntoView(container, selectedTab);
  }, [...dependencies, enabled]);

  return containerRef;
}
